import { callStateAtom } from "@/Components/VideoRooms/VideoParts/videoAtoms";
import { CallState } from "@/types/callState";
import { useIdentity } from "@/utils/identity";
import classNames from "classnames";
import { useAtomValue } from "jotai";
import { PropsWithChildren } from "react";
import Popover from "../Popover";

type GoalsBoardPopoverProps = PropsWithChildren<{
    desktopOnly?: boolean;
}>;

export default function GoalsBoardPopover({
    children,
    desktopOnly = false,
}: GoalsBoardPopoverProps) {
    const { user } = useIdentity();
    const callState = useAtomValue(callStateAtom);

    return (
        <Popover
            popoverId="goals-board-popover"
            title={
                <div className="relative flex flex-col text-sm gap-2 max-w-72 p-2">
                    <div className="font-bold">
                        You can now check off your in progress action items and
                        habits
                    </div>
                    <div>
                        Mark them as complete as you work on them between
                        sessions. Your coach will be notified when you make
                        progress.
                    </div>
                </div>
            }
            disabled={callState !== CallState.Closed || user?.type !== "client"}
            position="top"
            controlledOpen={true}
            wrapperContainerClassName="!flex flex-col items-stretch"
            showWhenScrolledAway={true}
            popupContainerClassName={classNames(
                "!z-10",
                desktopOnly && "hidden lg:flex",
            )}
        >
            {children}
        </Popover>
    );
}
